import React from 'react';
import { Card, CardTitle, CardText, CardMedia } from 'react-toolbox/lib/card';
import TextBlock from '../../../../common/components/TextBlock';

const IssueItem = ({ icon, title, backgroundColor, color, text, style }) => {
  return (
    <Card style={style}>
      <CardMedia
        style={{
          backgroundColor,
          alignItems: 'center',
        }}
      >
        <span
          className="material-icons"
          style={{
            textAlign: 'center',
            color: color,
            fontSize: '6rem',
            lineHeight: '10rem',
          }}
        >
          {icon}
        </span>
      </CardMedia>
      <CardTitle title={title} />
      <CardText>
        <TextBlock>{text}</TextBlock>
      </CardText>
    </Card>
  );
};

export default IssueItem;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/IssueItem.js